import { render } from "./BodyWarpper.vue?vue&type=template&id=086166d4&scoped=true"
import script from "./BodyWarpper.vue?vue&type=script&lang=js"
export * from "./BodyWarpper.vue?vue&type=script&lang=js"

import "./BodyWarpper.vue?vue&type=style&index=0&id=086166d4&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086166d4"]])

export default __exports__